import * as React from 'react';

import { Filters } from 'shared/types/candidates-search';
import { CandidatesSearchUserPreset } from '../components/candidates-search-user-presets';

export const BlacklistedCandidatesPage: React.FC<{}> = () => {
    const filters: Partial<Filters> = { blacklistedOnly: true };
    return <CandidatesSearchUserPreset filters={filters} title="Blacklisted" />;
};
